import React from 'react';
import { SWRConfig } from 'swr';

export const swrDefaults = {
  refreshInterval: 120000,
  revalidateOnFocus: true,
  revalidateOnReconnect: true,
  errorRetryCount: 3,
  errorRetryInterval: 2000,
  dedupingInterval: 5000,
  keepPreviousData: true,
  // Auth failures don't heal by retrying: a step_up_required 403 is already
  // handled (one QR prompt + one retry) inside the axios interceptor, so an
  // SWR retry here would only re-trigger the prompt in a loop.
  onErrorRetry: (error, _key, config, revalidate, { retryCount }) => {
    const status = error?.response?.status ?? error?.status;
    if (status === 401 || status === 403) return;
    if (retryCount >= config.errorRetryCount) return;
    setTimeout(() => revalidate({ retryCount }), config.errorRetryInterval);
  },
};

export function SWRProvider({ children }) {
  return (
    <SWRConfig value={swrDefaults}>
      {children}
    </SWRConfig>
  );
}

export default SWRProvider;
